import React from "react";
import {List} from "../modules/HarvestsReports";

export function TotalReportsPage() {
  return (
    <List />
  );
}
